
import { Button, Card, Col, Row, Collapse, Form, Container, Spinner, ProgressBar } from "react-bootstrap";
import { BsPlusLg, BsCheckCircleFill } from "react-icons/bs"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiFilter3Line } from "react-icons/ri"
import Multiselect from 'multiselect-react-dropdown';
import dayjs from "dayjs";
import { FaCheckCircle, FaRegCalendarAlt, } from "react-icons/fa";
import ModalPermessi from "../../../Utilities/ModalPermessi";
import PaginationBasic from "../../Homepage/Pagination";
import RisposteSondaggioService from "../../../../services/RisposteSondaggioService";
import SondaggioPartecipanteService from "../../../../services/SondaggioPartecipanteService";
import '../../../Admin/Sondaggi/Sondaggi.css'
import PaginaGrazie from "./PaginaGrazie";
import sondaggioNonCompletato from '../../../../immagini/sondaggi/sondaggioNonConcluso.jpg'; // o l’immagine che hai tu
import { esportaPDFSondaggio } from "../../../Utilities/eportaPDF";
import { useRef } from "react"; // se non l'hai già importato
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DomandaGraficoPdfContent from "../../../Admin/Sondaggi/Risposte/DomandaGraficoPDFContent";



/*
sondaggio={sondaggio}
comune={props.comune}
partecipante={props.partecipante}
loadingSon={loadingSon}
*/

export default function EsploraRisposteSondaggio(props) {

  const [risposte, setRisposte] = useState([])
  const [sondaggioPartecipante, setSondaggioPartecipante] = useState([])

  const [exportingPdf, setExportingPdf] = useState(false);

  const pdfElementRefs = useRef({});


  useEffect(() => {
    if (props.sondaggio?.sonId) {
      RisposteSondaggioService.getRisposteBySondaggio(props.sondaggio.sonId)
        .then(res => setRisposte(res.data))
        .catch(err => console.error("Errore nel recupero risposte", err));
    }
  }, [props.sondaggio]);

  useEffect(() => {
    if (props.partecipante?.parId && props.sondaggio?.sonId) {
      SondaggioPartecipanteService.getBySondaggioAndPartecipante(
        props.sondaggio.sonId,
        props.partecipante.parId
      ).then(res => setSondaggioPartecipante(res.data));
    }
  }, [props.partecipante, props.sondaggio]);


  const esportaPDF = async () => {

    if (!props.sondaggio || !risposte || exportingPdf) return;
    setExportingPdf(true);
    const doc = new jsPDF("p", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 12; // Margine sinistro/destro
    const contentWidth = pageWidth - 2 * margin; // Larghezza utile
    let y = margin; // Posizione Y iniziale

    const pdfRefsMap = pdfElementRefs.current; // Usa il  ref

    // Funzione helper per gestire i cambi pagina
    const addPageIfNeeded = (neededHeight) => {
      if (y + neededHeight > pageHeight - margin) {
        doc.addPage();
        return margin; // Reset y to top margin
      }
      return y;
    };

    try {
      // --- PASSO 1: Calcola Altezza Totale Intestazione ---
      let totalHeaderHeight = 0;
      const tempDoc = new jsPDF("p", "mm", "a4"); // Usa un doc temporaneo per calcoli
      const centerX = pageWidth / 2;

      // Altezza Titolo
      tempDoc.setFontSize(25);
      tempDoc.setFont(undefined, 'bold');
      totalHeaderHeight += tempDoc.getTextDimensions(props.sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6; // + spazio sotto

      // Altezza Descrizione
      tempDoc.setFontSize(16);
      tempDoc.setFont(undefined, 'normal');
      let descHeight = 0;
      if (props.sondaggio.sonDescrizione) {
        const descLines = tempDoc.splitTextToSize(props.sondaggio.sonDescrizione, contentWidth);
        descHeight = tempDoc.getTextDimensions(descLines).h;
        totalHeaderHeight += descHeight + 4; // + spazio sotto
      }

      // Altezza Periodo
      let periodoHeight = 0;
      if (props.sondaggio.sonDataInizioSondaggio && props.sondaggio.sonDataFineSondaggio) {
        const periodoText = `${new Date(props.sondaggio.sonDataInizioSondaggio).toLocaleDateString()} - ${new Date(props.sondaggio.sonDataFineSondaggio).toLocaleDateString()}`;
        periodoHeight = tempDoc.getTextDimensions(periodoText, { maxWidth: contentWidth }).h;
        totalHeaderHeight += periodoHeight + 10; // + spazio sotto
      } else {
        totalHeaderHeight += 10; // Spazio aggiunto anche se non c'è periodo
      }

      // Altezza Banner (richiede caricamento immagine)
      let bannerHeight = 0;
      if (props.sondaggio?.sonBanner && props.sondaggio?.sonBannerNome) {
        const ext = props.sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
        const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
        const bannerDataUrl = `data:${mime};base64,${props.sondaggio.sonBanner}`;
        const bannerImg = new Image();
        bannerImg.src = bannerDataUrl;
        try {
          await new Promise((resolve, reject) => {
            bannerImg.onload = resolve;
            bannerImg.onerror = reject; // Gestisci errore caricamento
          });
          bannerHeight = (bannerImg.height * contentWidth) / bannerImg.width;
          totalHeaderHeight += bannerHeight + 10; // + spazio sotto
        } catch (imgError) {
          console.error("Errore caricamento banner per calcolo altezza:", imgError);
          // Non aggiungere altezza banner se non si carica
        }
      }
      // Rimuovi l'ultimo spazio aggiunto se non c'è banner o se non si è caricato
      if (bannerHeight === 0) {
        if (periodoHeight > 0) totalHeaderHeight -= 10; // Rimuovi spazio dopo periodo
        else if (descHeight > 0) totalHeaderHeight -= 4; // Rimuovi spazio dopo descrizione
        else totalHeaderHeight -= 6; // Rimuovi spazio dopo titolo
      }


      // --- PASSO 2: Calcola Y Iniziale per Centratura Verticale ---
      const availableHeight = pageHeight - 2 * margin;
      let startY = margin; // Default: inizia dal margine superiore

      if (totalHeaderHeight < availableHeight) {
        // Solo se l'altezza totale è minore dello spazio disponibile
        startY = margin + (availableHeight - totalHeaderHeight) / 2;
      }
      y = startY; // Imposta la y iniziale calcolata

      // --- PASSO 3: Disegna Effettivamente gli Elementi ---

      // Titolo
      doc.setFontSize(25);
      doc.setFont(undefined, 'bold');
      doc.text(props.sondaggio.sonTitolo || 'Sondaggio', centerX, y, { align: 'center' });
      y += doc.getTextDimensions(props.sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6;
      doc.setFont(undefined, 'normal');
      doc.setFontSize(16);

      // Descrizione
      if (props.sondaggio.sonDescrizione) {
        // Usa l'altezza già calcolata 'descHeight'
        doc.text(props.sondaggio.sonDescrizione, centerX, y, { align: 'center', maxWidth: contentWidth });
        y += descHeight + 4;
      }

      // Periodo
      if (props.sondaggio.sonDataInizioSondaggio && props.sondaggio.sonDataFineSondaggio) {
        // Usa l'altezza già calcolata 'periodoHeight'
        const periodoText = `${new Date(props.sondaggio.sonDataInizioSondaggio).toLocaleDateString()} - ${new Date(props.sondaggio.sonDataFineSondaggio).toLocaleDateString()}`;
        doc.text(periodoText, centerX, y, { align: 'center', maxWidth: contentWidth });
        y += periodoHeight + 10;
      } else {
        y += 10; // Spazio aggiunto anche se non c'è periodo
      }

      // Banner
      if (bannerHeight > 0) { // Disegna solo se l'altezza è stata calcolata correttamente
        // Ricarica l'immagine o usa quella già caricata se l'hai salvata
        const ext = props.sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
        const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
        const bannerDataUrl = `data:${mime};base64,${props.sondaggio.sonBanner}`;
        // Non serve await qui se l'immagine è già stata caricata per il calcolo altezza
        doc.addImage(bannerDataUrl, mime.toUpperCase().replace('JPEG', 'JPG'), margin, y, contentWidth, bannerHeight);
        y += bannerHeight + 10;
      }
      // Rimuovi l'ultimo spazio se non c'era banner
      if (bannerHeight === 0) {
        if (periodoHeight > 0) y -= 10;
        else if (descHeight > 0) y -= 4;
        else y -= 6;
      }


      // --- Cambio Pagina Forzato ---
      doc.addPage();
      y = margin; // Resetta y per la nuova pagina

      const allSectionsSorted = props.sondaggio.sezioni
        .sort((a, b) => a.sezPosizione - b.sezPosizione);

      for (const sezione of allSectionsSorted) {

        // ***** INIZIO: Aggiungi Titolo Sezione *****
        const sezioneTitle = `Sezione ${sezione.sezPosizione} - ${sezione.sezNome}`;
        doc.setFontSize(14); // Dimensione font per titolo sezione
        doc.setFont(undefined, 'bold'); // Grassetto per titolo sezione
        const titleHeightEst = doc.getTextDimensions(sezioneTitle, { maxWidth: contentWidth, fontSize: 14 }).h; // Stima altezza titolo
        const neededSpaceForTitle = titleHeightEst + 8; // Altezza titolo + spazio sotto

        y = addPageIfNeeded(neededSpaceForTitle); // Controlla se c'è spazio PRIMA di scrivere il titolo

        doc.text(sezioneTitle, margin, y, { maxWidth: contentWidth });
        y += titleHeightEst + 8; // Incrementa y DOPO aver scritto il titolo + spazio

        // Reimposta font per le domande (se necessario)
        doc.setFontSize(11); // O la dimensione che usi in DomandaGraficoPdfContent per h6
        doc.setFont(undefined, 'normal');
        // ***** FINE: Aggiungi Titolo Sezione *****


        const domandeOrdinate = sezione.domande
          .sort((a, b) => a.domNumPosizione - b.domNumPosizione);

        for (const domanda of domandeOrdinate) {
          const elementToCapture = pdfRefsMap[`pdf-domanda-${domanda.domId}`];

          if (elementToCapture) {
            try {
              await new Promise(resolve => setTimeout(resolve, 100)); // Delay

              const scale = 2;
              const canvas = await html2canvas(elementToCapture, {
                scale: scale,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: -window.scrollY,
                windowWidth: elementToCapture.scrollWidth,
                windowHeight: elementToCapture.scrollHeight
              });
              const imgData = canvas.toDataURL("image/png", 1.0);

              const imgProps = doc.getImageProperties(imgData);
              const pdfImgWidth = contentWidth;
              const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;

              // Controlla spazio per l'immagine della domanda
              y = addPageIfNeeded(pdfImgHeight + 10); // Spazio per immagine + margine sotto

              doc.addImage(imgData, "PNG", margin, y, pdfImgWidth, pdfImgHeight);
              y += pdfImgHeight + 10; // Spazio dopo l'immagine

            } catch (canvasError) {
              console.error(`Errore html2canvas per domanda ${domanda.domId}:`, canvasError);
              const errorText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Errore generazione grafico)`;
              const errorHeight = doc.getTextDimensions(errorText, { maxWidth: contentWidth, fontSize: 10 }).h;
              y = addPageIfNeeded(errorHeight + 5);
              doc.setFontSize(10);
              doc.setTextColor(255, 0, 0);
              doc.text(errorText, margin, y, { maxWidth: contentWidth });
              y += errorHeight + 5;
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(11); // Reimposta dimensione font
            }
          } else {
            console.warn(`Ref PDF non trovato per pdf-domanda-${domanda.domId}. Skipping in PDF.`);
            const warningText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Elemento non catturato)`;
            const warningHeight = doc.getTextDimensions(warningText, { maxWidth: contentWidth, fontSize: 10 }).h;
            y = addPageIfNeeded(warningHeight + 5);
            doc.setFontSize(10);
            doc.setTextColor(150, 150, 0);
            doc.text(warningText, margin, y, { maxWidth: contentWidth });
            y += warningHeight + 5;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(11); // Reimposta dimensione font
          }
        } // Fine loop domande

        // Aggiungi un po' di spazio extra tra la fine di una sezione e l'inizio della successiva (o la fine pagina)
        y += 5;

      } // Fine loop sezioni

      doc.save(`report_${props.sondaggio?.sonTitolo?.replace(/[^a-z0-9]/gi, '_') || 'sondaggio'}.pdf`);

    } catch (error) {
      console.error("Errore durante l'esportazione PDF:", error);
      // Mostra messaggio errore all'utente
    } finally {
      setExportingPdf(false); // Nascondi spinner
    }
  };


  return (
    <>
      <Card style={{ minHeight: "50vh", borderTop: "none", borderRadius: "0px" }}>
        {props.sondaggio?.sonStato === "Concluso" && (
          <div className="d-flex justify-content-end mb-4 mt-2 mr-4">
            <Button
              variant="primary"
              onClick={esportaPDF}
              disabled={exportingPdf}
            >
              {exportingPdf ? "Esportando..." : "Esporta PDF"}
            </Button>
          </div>
        )}
        {(!risposte || !props.sondaggio || !sondaggioPartecipante) ? (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
            <Spinner animation="border" role="status" variant="primary" />
            <span className="mt-3 text-muted">Caricamento in corso...</span>
          </div>
        ) : props.sondaggio.sonStato !== "Concluso" ? (
          <PaginaGrazie
            titolo="Il sondaggio non è ancora concluso"
            sottotitolo="Appena sarà terminato potrai vedere i risultati e scoprire cosa hanno detto gli altri partecipanti."
            bottone="Torna ai sondaggi"
            immagine={sondaggioNonCompletato}
          />
        ) : (
          <>
            {props.sondaggio?.sezioni?.map((sezione, indexSez) => (
              <div key={sezione.sezId} className="p-4 border-bottom">
                <h4 className="text-black mb-3">{sezione.sezNome}</h4>

                <Row>
                  {sezione.domande.map((domanda, indexDom) => (
                    <Col key={domanda.domId} xs={12} md={6} className="mb-4">
                      <Card className="shadow-sm h-100">
                        <Card.Header
                          className="text-white text-center"
                          style={{ backgroundColor: "#18548C" }}
                        >
                          <strong>{indexDom + 1}. {domanda.domDomanda}</strong>
                        </Card.Header>



                        <Card.Body className="p-3" style={{ borderRadius: "0 0 0.5rem 0.5rem" }}>
                          {domanda.opzioniRisposte.map((opzione) => {
                            const totalRisposte = risposte?.filter(r => r.domandaId === domanda.domId).length;
                            const rispostePerOpzione = risposte?.filter(
                              r => r.domandaId === domanda.domId && r.opzioneRispostaId === opzione.opzRisId
                            );
                            const percentuale = totalRisposte > 0 ? (rispostePerOpzione.length / totalRisposte * 100).toFixed(1) : 0;

                            const isRispostaUtente = sondaggioPartecipante?.risposte?.some(
                              r =>
                                r.domandaId === domanda.domId &&
                                r.opzioneRispostaId === opzione.opzRisId
                            );

                            return (
                              <div key={opzione.opzRisId} className="mb-3">
                                <div className="bg-light rounded-pill px-3 py-2 d-flex justify-content-between align-items-center" style={{ position: 'relative' }}>
                                  <div
                                    className="position-absolute top-0 start-0 h-100  rounded-pill"
                                    style={{
                                      width: `${percentuale}%`,
                                      zIndex: 0,
                                      transition: "width 0.3s",
                                      opacity: 0.9,
                                      backgroundColor: "#74AADC"
                                    }}
                                  ></div>
                                  <div className="position-relative w-100 d-flex justify-content-between align-items-center" style={{ zIndex: 2 }}>
                                    <span className="fw-semibold text-dark">
                                      {opzione.opzRisTesto}
                                      {/*isRispostaUtente && (
                                        <BsCheckCircleFill className="ms-2 text-primary" style={{ fontSize: "1rem" }} />
                                      )*/}
                                    </span>
                                    <span className="fw-bold text-dark">{percentuale}%</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>

              </div>
            ))}</>)
        }

      </Card>

      {Array.isArray(props.sondaggio?.sezioni) && risposte && (
        <div style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '700px', zIndex: '-1' }}>
          {props.sondaggio.sezioni
            .sort((a, b) => a.sezPosizione - b.sezPosizione)
            .map(sezione =>
              sezione.domande
                .sort((a, b) => a.domNumPosizione - b.domNumPosizione)
                .map(domanda => (
                  <div
                    key={`pdf-${domanda.domId}`}
                    ref={el => {
                      if (el) {
                        pdfElementRefs.current[`pdf-domanda-${domanda.domId}`] = el;
                      } else {
                        delete pdfElementRefs.current[`pdf-domanda-${domanda.domId}`];
                      }
                    }}
                  >
                    <DomandaGraficoPdfContent
                      domanda={domanda}
                      risposte={risposte}
                    />
                  </div>
                ))
            )}
        </div>
      )}




    </>
  )
}